import request from "@utils/request";

/**
 * 题库列表
 */
export function getTopicBank(data) {
  return request.get("/topicBank", data, { login: true });
}

/**
 * 答题记录
 */
export function getDatiRecord(data) {
  return request.get("/datiRecord", data, { login: true });
}

/**
 * 答题记录
 */
export function getDatiRecordList(data) {
  return request.get("/datiRecordList", data, { login: true });
}

/**
 * 问卷记录
 */
export function getServeyRecordList(data) {
  return request.get("/serveyRecordList", data, { login: true });
}

/**
 * 问卷记录
 */
export function getServeyRecord(data) {
  return request.get("/serveyRecord", data, { login: true });
}

/**
 * 获取调查时间
 */
export function getTime(data) {
  return request.get("/surveyTime", data, { login: true });
}

/**
 * 建立调查记录
 */
export function creatSurvey(data) {
  return request.post("/creatSurvey", data, { login: true });
}

/**
 * 获取调查列表
 */
export function getSurveyAnswer(data) {
  return request.get("/surveyAnswer", data, { login: true });
}

/**
 * 每日答题提交
 */
 export function putSurveyAnswer(data) {
  return request.post("/putSurveyAnswer", data, { login: true });
}

/**
 * 每日答题列表
 */
export function getTodayAnswer(data) {
  return request.get("/todayAnswer", data, { login: true });
}

/**
 * 入党问题列表
 */
export function getPartAnswer(data) {
  return request.get("/partAnswer", data, { login: true });
}

/**
 * 入党问题信息
 */
export function getPartAnswerInfo(data) {
  return request.get("/getPartAnswerInfo", data, { login: true });
}


/**
 * 每日答题提交
 */
 export function putAnswer(data) {
  return request.post("/putAnswer", data, { login: true });
}

/**
 * 入党答题提交
 */
 export function putPartAnswer(data) {
  return request.post("/putPartAnswer", data, { login: true });
}

/**
 * 挑战答题信息
 */
 export function getChallDeatil(data) {
  return request.get("/getChallDeatil", data, { login: true });
}

/**
 * 挑战答题题目
 */
 export function challAnserer(data) {
  return request.get("/challAnserer", data, { login: true });
}


/**
 * 挑战答题提交
 */
 export function putchall (data) {
  return request.post("/putchall", data, { login: true });
}

/**
 * 视频答题列表
 */
 export function videoList (data) {
  return request.get("/video/list", data, { login: true });
}

/**
 * 视频答题详情
 */
 export function videoDetail (data) {
  return request.get("/video/detail", data, { login: true });
}

/**
 * 提交视频答题答案
 */
 export function nextquestion (data) {
  return request.post("/video/nextquestion", data, { login: true });
}


/**
 * 积分榜
 */
 export function Scoreboard (data) {
  return request.get("/Scoreboard", data, { login: true });
}

/**
 * 挑战榜
 */
 export function Challenge (data) {
  return request.get("/Challenge", data, { login: true });
}